import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import HeaderFont from '@components/atoms/HeaderFont';
import Wrapper from '@components/atoms/Wrapper';
import Media from '@components/atoms/Media';
import Link from '@components/atoms/Link';

const FocusContentLink = ({ data, ...props }) => {
  const { title, linkTitle, url, image = null } = data;

  return (
    <Wrapper narrow>
      <Flex
        mb={{ base: `14`, md: `16` }}
        background="linear-gradient(290.45deg, rgba(219, 201, 255, 0.8) 0%, #ECD6F5 51.13%)"
        backdropFilter="blur(0.125rem)"
        color="white"
        alignItems="center"
        {...props}>
        {image !== null && (
          <Media
            maxWidth="30rem"
            minWidth="32"
            media={image}
            width={{ base: `30%`, md: `20%` }}
            height="100%"
            alignSelf={{ base: null, md: `flex-end` }}
            ml={{ md: `10` }}
          />
        )}
        <Box
          w="100%"
          flex="1"
          textAlign={{ base: `left`, md: `center` }}
          position="relative"
          p={{ base: `2rem 1rem`, sm: `2rem`, md: `2rem 2.5rem 2rem 0` }}>
          <HeaderFont
            as="h4"
            pb="0.532rem"
            fontSize={{ base: `xl`, sm: `2xl`, md: `3xl` }}
            fontStyle="italic"
            color="purple.600"
            lineHeight="2rem">
            {title}
          </HeaderFont>
          <Link href={url} variant="ghostButton" width="auto">
            <HeaderFont as="span" textTransform="uppercase">
              {linkTitle}
            </HeaderFont>
          </Link>
        </Box>
      </Flex>
    </Wrapper>
  );
};

export default FocusContentLink;
